import React from 'react';
import { Route } from 'react-router-dom';

export interface AppRouteDefinition {
  key: string;
  path?: string;
  index?: boolean;
  element: React.ReactElement;
}

export const renderRouteDefinitions = (
  routes: AppRouteDefinition[]
): React.ReactElement[] =>
  routes.map(({ key, path, index, element }) => (
    <Route key={key} path={path} index={index} element={element} />
  ));
